<ion-input class="input" style="border: none;" [hidden]="to.hidden" [formControl]="formControl"
	[ngStyle]="to.uppercase? {'text-transform': 'uppercase'} : {}" maxlength="9" diInputNoSpaces>
</ion-input>